import { path, pathOr, map } from 'ramda'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { SmallText } from '../../../../packages/kiti/components/presentation/Text'
import Button from '../../../../packages/kiti/components/actions/Button'
import DynamicInput from '../../../../components/form/DynamicInput'
import Modal, { ModalHeader } from '../../../../components/structure/Modal'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import { useBulkGridActions, useBulkGridRows, useBulkGridSelection, useBulkGridWideEditorTarget } from './_state/BulkGridStateContext'

// Painel completo (foto, assinatura, geolocalização, estoque, plano de ação,
// integração ou bloco de sub-perguntas) para UMA atividade+pergunta
// específica — reaproveita o mesmo `DynamicInput` da execução individual.
// Mudanças aqui aplicam-se imediatamente, com a mesma regra de multi-edição
// das células simples: se a linha estiver marcada, replica para as demais
// marcadas.
const WideCellModal = () => {
  const target = useBulkGridWideEditorTarget()
  const rows = useBulkGridRows()
  const { setCellValue, closeWideEditor } = useBulkGridActions()
  const { selected } = useBulkGridSelection()

  const row = target && rows.find(item => item.serviceOrder.id === target.serviceOrderId)
  const reply = row && row.replies.find(item => item.questionId === target.questionId)

  if (!target || !row || !reply) return false

  const question = reply.question
  const options = pathOr([], ['options'], question)
  const masks = map(path(['pattern']), pathOr([], ['masks'], question))
  const isMultiEditing = selected.has(row.serviceOrder.id) && selected.size > 1

  return (
    <Modal open width="40rem" zIndex={1100} onClose={closeWideEditor}>
      <ModalHeader
        title={question?.name}
        subtitle={`${row.serviceOrder.yearlyId || ''}${row.serviceOrder.name ? ` — ${row.serviceOrder.name}` : ''}`}
      />
      <Separator paddingH={1.5} paddingV={1.5}>
        {isMultiEditing && (
          <>
            <SmallText color="orange" bold>
              {selected.size} atividades marcadas — a resposta será aplicada a todas elas.
            </SmallText>
            <Separator weight={4} />
          </>
        )}

        <DynamicInput
          valueType={question?.type?.name}
          value={reply.value}
          allowNull={question?.allowNull}
          options={options}
          masks={masks}
          blockQuestions={question?.blockQuestions}
          integrationFieldType={question?.data?.integration?.integrationFieldType}
          integrationId={question?.data?.integration?.integrationId}
          {...(question?.data || {})}
          onChange={value => setCellValue(row.serviceOrder.id, reply.questionId, value)}
        />

        <Separator weight={12} />
        <Grid justify="flex-end">
          <Col>
            <Button color="primary" onClick={closeWideEditor}>
              Concluído
            </Button>
          </Col>
        </Grid>
      </Separator>
    </Modal>
  )
}

export default WideCellModal
